function copy_address_equipment(company_id){
	$.ajax({
		url:'/user_request.php',
		type:'post',
		beforeSend:function(){},
		data:{
			what: 'get_company_equip',
			company_id: company_id
		},
		dataType:'html',
		complete:function(html){
			if(html.responseText){
				$('#pop-box').html(html.responseText);

				$("#login-wrapper").fadeIn(500);
				$("#pop-box").fadeIn(500);
				$("#pop-box").css('top',window.screen.height/2-350+$(window).scrollTop());
			}
			else {
				$('#pop-box').html('');
				$("#login-wrapper").fadeOut(500);
				$("#pop-box").fadeOut(500);
			}
		},
		cache:false,
		async:true
	});
}

function check_company(company_name, opf){
	if (company_name.length > 0) {
		//console.log();
		$.ajax({ 
			url: '/user_request.php',
			type: 'post',
			beforeSend: function() {
			
			},
			data: {
				what: 'check_company',
				name : company_name,
				opf: opf
			},
			dataType:'html',
			complete: function(html) {
				var result = html.responseText.trim().split('|');
				if (result[0] != 'Error') {
					$('#butn input').removeAttr("disabled").removeClass("disabled");
					$('.error_msg').empty().addClass('hidden');
					$('#delegation_request').attr("disabled", "disabled").addClass("hidden");
				}
				else {
					if (typeof result[2] == 'undefined') {
						$('#butn input').attr("disabled", "disabled").addClass("disabled");
						$('#delegation_request').attr("disabled", "disabled").addClass("hidden");
						$('#c_id').remove();
					}
					else {
						$('#delegation_request').removeAttr("disabled").removeClass("disabled").removeClass("hidden");
						$('#pop-cols').append($('<input>').attr({type: 'hidden', id: 'c_id', name: 'c_id', value: result[2]}));
					}
					$('.error_msg').removeClass('hidden').removeClass('no_bg').html(result[1]).fadeIn();
				}
			},
			cache: false,
			async: true
		});	
	}
	else {
		$('#butn input').attr("disabled","disabled").addClass("disabled");
		$('.error_msg').empty().addClass('hidden');
		$('#delegation_request').attr("disabled", "disabled").addClass("hidden");
		$('#c_id').remove();						
	}
}
function set_company_ishop(company_id, obl_tip_count, checked){
	//console.log(checked);
	if (checked == true && obl_tip_count > 0) { 
		var answer = confirm('Внимание! Все области дейтельности, кроме интернет-торговли, у всех адресов в компании будут удалены! Продолжить?'); 
		if (answer == false) 
			$("input[name='i_shop']").prop('checked', false);
	}	

	if (answer == undefined || (answer == true && obl_tip_count > 0)) {
		$.ajax({ 
			url: '/user_request.php',
			beforeSend: function() {
				//$('#load-import').removeClass("hidden");
			},
			type: 'post',
			data: {
				what: 'set_company_i_shop',
				company_id: company_id,
				obl_tip_count: obl_tip_count,
				checked: checked
			},
			dataType: 'html',
			complete: function(html) {
				var result = html.responseText.trim().split('|');
				if (result[0] == 'Error') {
					$('.error_msg').removeClass('hidden').removeClass('no_bg').html(result[1]).fadeIn();
				}
			},
			cache: false,
			async: true
		});	
	}
}
							
function company_is_change(){$('#saveButton').prop('disabled',false);$('#saveButton').removeClass('noactive');$('#saveModButton').prop('disabled',false);$('#saveModButton').removeClass('noactive');}
function set_preview_position(obj,section,company_id){var position=$(obj).position();var height=$("#box-"+section).height();var delta=height-position.top;var block_height=$("#preview_"+section+"_"+company_id).height()+62;if(delta<block_height/2&&delta>0)
var top=position.top-(block_height-delta);else
var top=position.top-90;if(top<21)
top=21;$('#box-'+section+' .brands_preview').css('top',top);}
function closePop(){$('#pop-box').html('');$("#login-wrapper").fadeOut(500);$("#pop-box").fadeOut(500);}
var current_company=0;function show_company(compid,show){if(compid>0){if(show==1){var comY=pageY(document.getElementById('complist_'+compid));var infY=pageY(document.getElementById('complist_begin'));var delta=comY-infY;delta-=200;if(delta<0)
delta=0;var companyListHeight=$("#company-list ul").height();if(delta>companyListHeight)
delta=companyListHeight;$('.complist').removeClass('active');$('.liup').removeClass('upper_active');$('#company-info').animate({'top':delta+'px'},0,function(){$('#complist_'+compid).addClass('active');});$('.liup_'+compid).addClass('upper_active');$('.current_company').hide();$('#company_right_'+compid).show();var pagY=pageY(document.getElementById('complist_pages'));var botY=pageY(document.getElementById('complist_bottom'));if(botY>pagY){delta-=botY;delta+=pagY;if(delta<0)
delta=0;$('#company-info').animate({'top':delta+'px'},0,function(){$('#complist_'+compid).addClass('active');});}}
current_company=compid;}}
var default_values=[];function check_text(a,len){var pos=getCaretPos(document.getElementById(a));if(!len)
len=500;var text=$('#'+a).val();if(typeof default_values!='undefined'&&jQuery.inArray(text,default_values)!=-1){$('#'+a+'_pre').css('color','');$('#'+a+'_more').text(len);}
else{if(text.length>=len){text=text.substr(0,len);$('#'+a).text(text);setCaretPos(document.getElementById(a),pos);$('#'+a+'_pre').css('color','red');}
else
$('#'+a+'_pre').css('color','');var more=len-text.length;$('#'+a+'_more').text(more);}}
var regexp_post_index = '';
function edit_address(){
if (regexp_post_index=='') regexp_post_index = '[0-9]{5,6}';
var error=true;if($('#city').val().length>0)
$('#city').removeClass('border_red');else{error=false;$('#city').addClass('border_red');}
if($('#descr').val().length>0)
$('#descr').removeClass('border_red');else{error=false;$('#descr').addClass('border_red');}
var company_site=$('#site').val();if(company_site){company_site=company_site.replace('http://','');company_site=company_site.replace('https://','');company_site=company_site.replace(/\s+/g,'');var regexp=/^([a-zа-я0-9]([a-zа-я0-9-]+)\.)+([a-zа-я]{2,})(\/.*)*$/i;if(regexp.test(company_site)&&company_site.length>6){$('#site').val(company_site);$('#site').removeClass('border_red');}
else{$('#site').addClass('border_red');error=false;}}
var post_index=$('#post_index').val();var c_id=$('#country_id').val();
var regexp = new RegExp('^\\b'+ regexp_post_index +'\\b$', 'i');
 
if(regexp.test(post_index)){$('#post_index').val(post_index);$('#post_index').removeClass('border_red');}
else{$('#post_index').addClass('border_red');error=false;}
var phone_kod=$('#phone_kod').val();if(typeof phone_kod!='undefined'){var regexp=/^\b[0-9]{2,5}\b/;if(regexp.test(phone_kod)){$('#phone_kod').val(phone_kod);$('#phone_kod').removeClass('border_red');}
else{$('#phone_kod').addClass('border_red');error=false;}}


var phone_number=$('#phone_number').val();
console.log(phone_number);
var regexp=/^\b[0-9]{5,9}\b/;if(regexp.test(phone_number)){$('#phone_number').val(phone_number);$('#phone_number').removeClass('border_red');}
else{$('#phone_number').addClass('border_red');error=false;}
return error;}
var map;var placemark;function show_yandex_map(from){gps_x=37.64;gps_y=55.76;gps_m=10;map=new YMaps.Map(document.getElementById("yandex_map"));map.addControl(new YMaps.Zoom());map.addControl(new YMaps.TypeControl());var good=0;if(from==1){gps1=document.getElementById('gps').value;gps=gps1.split(',');if(gps[0]>0&&gps[1]>0)
{good=1;gps_x=gps[0];gps_y=gps[1];gps_m=15;placemark=new YMaps.Placemark(new YMaps.GeoPoint(gps_x,gps_y));placemark.setOptions({draggable:true});YMaps.Events.observe(placemark,placemark.Events.DragEnd,function(obj)
{var gps=obj.getGeoPoint();map.panTo(gps);var new_addr=new YMaps.Geocoder(gps,{prefLang:"ru"})
YMaps.Events.observe(new_addr,new_addr.Events.Load,function(new_addr){});document.getElementById('gps').value=gps.getLng()+','+gps.getLat();});var gps1=placemark.getGeoPoint();document.getElementById('gps').value=gps1.getLng()+','+gps1.getLat();map.addOverlay(placemark);map.setCenter(new YMaps.GeoPoint(gps1.getLng(),gps1.getLat()),gps_m);map.panTo(gps1);}
else
{from=0;}}
if(from!=1)
{var addr_descr=$('#descr').val();if($('#city').val()){addr_descr=$('#city').val()+', '+addr_descr;}
if(addr_descr.length>0)
{var geocoder=new YMaps.Geocoder(addr_descr,{prefLang:"ru"});YMaps.Events.observe(geocoder,geocoder.Events.Load,function(geocoder){if(geocoder.get(0))
{placemark=geocoder.get(0);gps_m=15;placemark.setOptions({draggable:true});YMaps.Events.observe(placemark,placemark.Events.DragEnd,function(obj)
{var gps=obj.getGeoPoint();map.panTo(gps);var new_addr=new YMaps.Geocoder(gps,{prefLang:"ru"})
YMaps.Events.observe(new_addr,new_addr.Events.Load,function(new_addr){});document.getElementById('gps').value=gps.getLng()+','+gps.getLat();});var gps1=placemark.getGeoPoint();document.getElementById('gps').value=gps1.getLng()+','+gps1.getLat();map.addOverlay(placemark);map.setCenter(new YMaps.GeoPoint(gps1.getLng(),gps1.getLat()),gps_m);map.panTo(gps1);}
else
{map.setCenter(new YMaps.GeoPoint(gps_x,gps_y),gps_m);}});}
else
{map.setCenter(new YMaps.GeoPoint(gps_x,gps_y),gps_m);}}}
function get_edit_address_form(data){if(!data.width)data.width=990;if(!data.height)data.height=600;$.ajax({url:'/user_request.php',type:'post',beforeSend:function(){},data:{what:'get_user_edit_address_form',locale:data.locale,company_id:data.compid,addr_id:data.addrid,section:data.section,step:data.step,action:data.action},dataType:'html',complete:function(html){if(html.responseText){$('#pop-box').html(html.responseText);if(data.click){$('#'+data.click).click();$('.just_form').hide();$('#'+data.click).show();}
$("#login-wrapper").fadeIn(500);$("#pop-box").fadeIn(500);$("#pop-box").css('top',window.screen.height/2-data.height+$(window).scrollTop());}
else{$('#pop-box').html('');$("#login-wrapper").fadeOut(500);$("#pop-box").fadeOut(500);}},cache:false,async:true});}
function get_company_adv_form(data){if(!data.width)data.width=990;if(!data.height)data.height=600;$.ajax({url:'/user_request.php',type:'post',beforeSend:function(){},data:{what:'get_company_adv_form',company_id:data.compid,section:data.section,lk:data.lk},dataType:'html',complete:function(html){if(html.responseText){$('#pop-box').html(html.responseText);if(!data.lk){$(".datepicker").datepicker({monthNames:["Январь","Февраль","Март","Апрель","Май","Июнь","Июль","Август","Сентябрь","Октябрь","Ноябрь","Декабрь"],monthNamesShort:["Янв","Фев","Мар","Апр","Май","Июн","Июл","Авг","Сен","Окт","Ноя","Дек"],dayNamesMin:["Вс","Пн","Вт","Ср","Чт","Пт","Сб"],changeMonth:true,changeYear:true,dateFormat:"dd.mm.yy",firstDay:1,buttonImage:"/images/admin/calendar-icon.png"});if(data.minDate)
$(".datepicker").datepicker("option","minDate",data.minDate);if(data.maxDate)
$(".datepicker").datepicker("option","maxDate",data.maxDate);}
if(data.click){$('#'+data.click).click();$('.just_form').hide();$('#'+data.click).show();}
$("#login-wrapper").fadeIn(500);$("#pop-box").fadeIn(500);$("#pop-box").css('top',window.screen.height/2-data.height+$(window).scrollTop());}
else{$('#pop-box').html('');$("#login-wrapper").fadeOut(500);$("#pop-box").fadeOut(500);}},cache:false,async:true});}
function get_add_address_form(compid,locale,width,height)
{if(!width){width=990;}
if(!height){height=600;}
$.ajax({url:'/user_ajax_page.php',type:'post',beforeSend:function(){},data:{what:'get_user_add_address_form',locale:locale,company_id:compid},dataType:'html',complete:function(html){if(html.responseText)
{$('#pop-box').html(html.responseText);$("#login-wrapper").fadeIn(500);$("#pop-box").fadeIn(500);}
else
{$('#pop-box').html('');$("#login-wrapper").fadeOut(500);$("#pop-box").fadeOut(500);}},cache:false,async:true});}
function buy_service(service_id,val,comp_id){$.ajax({url:'/user_request.php',type:'post',beforeSend:function(){$('#loading-'+service_id).removeClass('hidden');},data:{what:'buy_service',service_id:service_id,val:val,comp_id:comp_id},dataType:'html',complete:function(html){if(html.responseText){$('#pop-box').html(html.responseText);$("#login-wrapper").fadeIn(500);$("#pop-box").fadeIn(500);$("#pop-box").css('top',window.screen.height/2-250+$(window).scrollTop());$('#loading-'+service_id).addClass('hidden');}
else{$('#pop-box').html('');$("#login-wrapper").fadeOut(500);$("#pop-box").fadeOut(500);}},cache:false,async:true});}
function buy_plan(plan_id){$.ajax({url:'/user_request.php',type:'post',beforeSend:function(){},data:{what:'buy_plan',plan_id:plan_id},dataType:'html',complete:function(html){if(html.responseText){$('#pop-box').html(html.responseText);$("#login-wrapper").fadeIn(500);$("#pop-box").fadeIn(500);$("#pop-box").css('top',window.screen.height/2-450+$(window).scrollTop());}
else{$('#pop-box').html('');$("#login-wrapper").fadeOut(500);$("#pop-box").fadeOut(500);}},cache:false,async:true});}
function show_big_div(width,height)
{if(!width){width=990;}
if(!height){height=600;}
var arrayPageSize=getPageSize();var scroll=get_scroll();var hei=arrayPageSize[1];$('#big_banner_div').css('height',hei+'px');nw=810;if(width>0){nw=width;}
var wid=(arrayPageSize[0]-nw)/2;var bh=scroll+100;$('#big_photo').css('top',bh+'px');$('#big_photo').css('left',wid+'px');nw=810;if(width>0){nw=width;}
$('#big_photo').css('width',nw+'px');nw=443;if(height>0){nw=height;}
nw=810;if(width>0){nw=width;}
wid+=+nw-22;hei=+bh-17;$('#close_big').css('top',hei+'px');$('#close_big').css('left',wid+'px');$('#big_banner_div').fadeIn(500);}
function close_big_div()
{$('#big_banner_div').fadeOut(500);$('#big_photo').html('');$('#left_big').html('');$('#right_big').html('');}